// eslint-disable-next-line import/prefer-default-export
export const LocalStorageItemKey = {
  SearchFilters: 'searchFilters',
  OfflineOfferUploadedOnListing: 'offlineOfferUploadedOnListing',
  OfferReminder: 'offerReminder',
  GrowSurf: 'grsf',
  CanSubmitListing: 'canSubmitListing',
  PhotoRequestFromMarketingSection: 'photoRequestFromMarketingSection',
};
